import { useLocation } from "react-router-dom";
import { VideoContext } from "./../context/VideoContext";
import React, { useEffect } from "react";

export const useResetScroll = () => {
	const { pathname } = useLocation();
	const context = React.useContext(VideoContext);

	useEffect(() => {
		window.scrollTo(0, 0);
		context.setVideo([]);

		if (pathname !== "/") {
			const root = document.getElementById("root");

			if (!root) {
				return;
			}

			root.style.height = "";
		}
	}, [pathname]);
};
